import { CancelButton } from '@src/main/shared/ui/components/button/cancel/CancelButton';
import { SaveButton } from '@src/main/shared/ui/components/button/save/SaveButton';
import { Dialog } from 'primereact/dialog';
import React, { FC } from 'react';

type AppDialogProps = {
  visible: boolean;
  title: string;
  onClose: () => void;
  onConfirm?: () => void;
  disableButtons?: boolean;
  children: React.ReactNode;
};

const AppDialog: FC<AppDialogProps> = ({
  visible,
  title,
  onClose,
  onConfirm,
  disableButtons = false,
  children,
}) => (
  <Dialog
    header={title}
    visible={visible}
    onHide={onClose}
    style={{ width: '50vw' }}
    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
    modal
    footer={
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
        <CancelButton onClick={onClose} />
        {onConfirm && <SaveButton onClick={onConfirm} loading={disableButtons} />}
      </div>
    }
  >
    {children}
  </Dialog>
);

export default AppDialog;
